export default __webpack_public_path__ + "static/media/up_scroll_icon_hover.49e45d32.png";